var ProductReviewDto = (function () {
    function ProductReviewDto(id, headline, rating, comments, nickname, bottomLine, created, media) {
        if (id === void 0) { id = ''; }
        if (headline === void 0) { headline = ''; }
        if (rating === void 0) { rating = 0; }
        if (comments === void 0) { comments = ''; }
        if (nickname === void 0) { nickname = ''; }
        if (bottomLine === void 0) { bottomLine = ''; }
        if (created === void 0) { created = 0; }
        if (media === void 0) { media = []; }
        this.id = id;
        this.headline = headline;
        this.rating = rating;
        this.comments = comments;
        this.nickname = nickname;
        this.bottomLine = bottomLine;
        this.created = created;
        this.media = media;
    }
    ProductReviewDto.fromOcapi = function (review) {
        var _a;
        var media = (_a = review.media) === null || _a === void 0 ? void 0 : _a.map(function (m) {
            return {
                createdDate: m.createdDate,
                updatedDate: m.updatedDate,
                helpfulVotes: m.helpfulVotes,
                notHelpfulVotes: m.notHelpfulVotes,
                caption: m.caption,
                featured: m.featured,
                id: m.id,
                type: m.type,
                reviewId: m.reviewId,
                nickname: m.nickname,
                uri: m.uri,
            };
        });
        return new ProductReviewDto(review.id, review.headline, review.rating, review.comments, review.nickname, review.bottomLine, review.created, media);
    };
    return ProductReviewDto;
}());
export { ProductReviewDto };
//# sourceMappingURL=ReviewDto.js.map